// extracted by mini-css-extract-plugin
export default {"titleContainer":"_2Q1a9IZl","title":"_1qkOeD_c","projectButtons":"_26iHjnPz","button":"_13-Y4hd5","noProjectsTitle":"_2jbGbllq"};